
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/teams-and-labs",
      function () {
        return require("private-next-pages/teams-and-labs.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/teams-and-labs"])
      });
    }
  